import React from 'react';
import {connect} from 'react-redux';

import HeaderOutcomePlace from './header-outcome-place-config.json';
import * as HeaderType from '../constants/HeaderType';

import ResultOutcome from './header/ResultOutcome.jsx';
import DoubleOutcome from './header/DoubleOutcome.jsx';
import HandicapOutcome from './header/HandicapOutcome.jsx';
import TotalOutcome from './header/TotalOutcome.jsx';

class MainLine extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        outcomes: React.PropTypes.object,
        outcomesStore: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.outcomes !== nextProps.outcomes
            || this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId;
    }

    render() {
        const {section, outcomes, outcomesStore, gridLocalization} = this.props;

        let resultOutcomeId = null;
        let doubleOutcomeId = null;
        let handicapOutcomeId = null;
        let totalOutcomeId = null;

        if (outcomes !== null) {
            const headerOutcomes = outcomes.map(h => {
                const o = outcomesStore.get(h);
                if (o.get('isHeader') === true) {
                    return o;
                }

                return undefined;
            }).filter(h => h !== undefined);


            for (let i = 0; i < headerOutcomes.size; i++) {
                const outcome = headerOutcomes.get(i);
                const outcomeId = outcome.get('id');

                const headerOutcomePlace = HeaderOutcomePlace[outcome.get('type')];

                switch (headerOutcomePlace) {
                    case HeaderType.RESULT:
                        resultOutcomeId = outcomeId;
                        break;

                    case HeaderType.DOUBLE:
                        doubleOutcomeId = outcomeId;
                        break;

                    case HeaderType.HANDICAP:
                        handicapOutcomeId = outcomeId;
                        break;

                    case HeaderType.TOTAL:
                        totalOutcomeId = outcomeId;
                        break;
                }
            }
        }

        const props = {
            section,
            gridLocalization
        };

        return (
            <span>
                <ResultOutcome id={resultOutcomeId} {...props} />
                <DoubleOutcome id={doubleOutcomeId} {...props} />
                <HandicapOutcome id={handicapOutcomeId} {...props} />
                <TotalOutcome id={totalOutcomeId} {...props} />
            </span>
        );
    }
}

function select(state, props) {
    const {section, id, gridLocalization} = props;
    const group = state.application.getIn([section, 'groups', id]);

    let outcomes = null;
    if (group !== undefined) {
        outcomes = group.get('outcomes');
    }

    return {
        section,
        gridLocalization,
        outcomes,
        outcomesStore: state.application.getIn([section, 'outcomes'])
    };
}

export default connect(select, null, null, false)(MainLine);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/MainLine.jsx